import IconInfo from '@apollo/icons/small/IconInfo.svg';
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormControl,
  Heading,
  Switch,
  Text,
  Tooltip,
} from '@apollo/orbit';
import React from 'react';

export function IgnoredConditionsCard({
  downgradeStaticChecks,
  downgradeDefaultValueChange,
  isDisabled,
  useGraphSettings,
  className,
  canWriteCheckConfiguration,
  onChangeDowngradeStaticChecks,
  onChangeDowgradeDefaultValueChange,
  onChangeUseGraphSettings,
}: {
  downgradeStaticChecks: boolean;
  downgradeDefaultValueChange: boolean;
  isDisabled: boolean;
  useGraphSettings?: boolean;
  className?: string;
  canWriteCheckConfiguration: boolean;
  onChangeDowngradeStaticChecks: (value: boolean) => void;
  onChangeDowgradeDefaultValueChange: (value: boolean) => void;
  onChangeUseGraphSettings?: (value: boolean) => void;
}) {
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>Ignored conditions</CardTitle>
        {useGraphSettings !== undefined && (
          <FormControl>
            {useGraphSettings && (
              <Tooltip label="Default to the settings configured by this graph.">
                <IconInfo className="text-placeholder" />
              </Tooltip>
            )}
            <Switch
              isDisabled={!canWriteCheckConfiguration}
              isChecked={useGraphSettings}
              onChange={() => {
                if (onChangeUseGraphSettings) {
                  onChangeUseGraphSettings(!useGraphSettings);
                }
              }}
            >
              Use graph settings
            </Switch>
          </FormControl>
        )}
      </CardHeader>
      <CardBody>
        <SwitchSetting
          title="Ignore breaking changes when there are no operations"
          description="Ignore any potentially breaking changes when an operation check is run against zero operations. If this option is on, checks will pass instead of fail in this case."
          isChecked={downgradeStaticChecks}
          isDisabled={isDisabled}
          onChange={onChangeDowngradeStaticChecks}
        />
        <SwitchSetting
          title="Ignore default value changes"
          description="When a schema change includes default values changes, don't consider that as potentially affected. If this option is on, checks will pass instead of fail in this case."
          isChecked={downgradeDefaultValueChange}
          isDisabled={isDisabled}
          onChange={onChangeDowgradeDefaultValueChange}
        />
      </CardBody>
    </Card>
  );
}

function SwitchSetting({
  title,
  description,
  isChecked,
  isDisabled,
  onChange,
}: {
  title: React.ReactNode;
  description: React.ReactNode;
  isChecked: boolean;
  isDisabled: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <div className="flex justify-between">
      <div className="flex-3 flex-col">
        <div>
          <Heading className="flex flex-row items-center gap-2" as="h3">
            {title}
            <span>
              <FormControl>
                <Switch
                  onChange={() => onChange(!isChecked)}
                  isChecked={isChecked}
                  isDisabled={isDisabled}
                />
              </FormControl>
            </span>{' '}
          </Heading>
        </div>
        <Text>{description}</Text>
      </div>
      <div className="flex-1" />
    </div>
  );
}
